module.exports = __webpack_public_path__ + "static/media/bg-clouds-stars.d1e61dfc.svg";